<template>
	<article class="d-news-page">
		<header>
			<h1
				v-if="name"
				class="text-[45px] mt-[35px] mb-[10px] font-light"
				v-html="name"
			></h1>
			<p
				v-if="teaser"
				class="text-22 <760:text-[14px] mt-[10px] mb-[20px]"
				v-html="teaser"
			></p>
		</header>

		<BlockList
			v-if="elements?.length"
			:block-list="elements"
			class="w-full mt-[10px] grid grid-cols-1 gap-[10px]"
		/>
	</article>
</template>

<script>
export default {
	inheritAttrs: false,
};
</script>

<script setup>
defineProps({
	id: Number,
	name: String,
	teaser: String,
	header: Object,
	elements: Array,
});
</script>

<style lang="postcss">
.d-news-page {
	@apply text-white flex flex-col justify-center w-full max-w-layout-max pb-[80px] mx-auto px-layout-margin;
}
</style>
